import { useQuery } from "react-query";
import useContractwiseApi from "hooks/api/useContractwiseApi";

export const useResourceQuery = (
  query,
  enabled = true,
  apiConfig = {},
  options = {}
) => {
  const { get } = useContractwiseApi();
  const queryPair = Array.isArray(query) ? query : [query, query];

  return useQuery(queryPair[1], get(queryPair[0], apiConfig), {
    ...options,
    enabled,
  });
};
